import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

/*Actions*/
import {
	getDocuments,
	saveFullCatalogDocuments
} from '../../../../redux/actions';

class FullCatalog extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: ''
		}
	}

	componentDidMount() {
		let { resources } = this.props.state;
		var self = this;
		self.setState({
			errorMessage: ''
		})
		if(!resources.fullCatalogDocuments) {
			// second param says whether it needs to be saved into store
			self.props.getDocuments('requestType=fullCatalog', true, response => {
				if(!response.status) {
					self.setState({
						errorMessage: 'Error occured while fetching documents.'
					})
				} else {
					response.responseObject = _.pullAllBy(response.responseObject, [{file: ""}], "file");
					self.props.saveClaimFormsDocuments(response);
				}
			});
		}
	}

	openDocument(url, event) {
		event.preventDefault();
		window.open(url);
	}

    render() {
		const { resources } = this.props.state;
	    return (
			<div>
		        <h1 className="pageTitle">Full Catalog</h1>
				<p className="bold red">{this.state.errorMessage}</p>
		        <div className="searchResults" style={{borderTop: 'none'}}>
					<table className="dataTable" width="70%">
						<thead>
							<tr>
								<th>Document</th>
							</tr>
						</thead>
			            <tbody>
							{resources.fullCatalogDocuments && resources.fullCatalogDocuments.responseObject && resources.fullCatalogDocuments.responseObject.map((item, index) => {
								return <tr key={index}>
									<td><a href="" onClick={this.openDocument.bind(this, item.url)}>{item.name}</a></td>
								</tr>
							})}
							{resources.fullCatalogDocuments && resources.fullCatalogDocuments.responseObject && resources.fullCatalogDocuments.responseObject.length === 0
								?<tr><td>No records found.</td></tr>
								:null
							}
						</tbody>
					</table>
		          	<div className="clear" />
				</div>
			</div>
	    );
  	}
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getDocuments: (queryStringParams, willSaveToStore, callback) => dispatch(getDocuments(queryStringParams, willSaveToStore, callback)),
	saveFullCatalogDocuments: (data) => dispatch(saveFullCatalogDocuments(data)),
});

FullCatalog = connect(mapStateToProps, mapDispatchToProps)(FullCatalog);
export default FullCatalog;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/FullCatalog/index.js